import { bdayPost, bdayGet, bdayPut } from 'services/utils';
import { queryDictToString } from 'components/utils/query';

const baseApi = '/api/1/card';
const baseCardsApi = '/api/1/cards';
const baseCardSendApi = '/api/1/card/send';
const baseCardCategoryApi = '/api/1/card_category';
const baseMyCardsApi = '/api/1/my_cards';

export const getCards = (data) => {
  const { ...queryDict } = data;
  const queryDictString = queryDictToString(queryDict);
  return bdayGet(`${baseCardsApi}/${data.ccid}${queryDictString}`);
}
export const getMyCards = (data) => {
  const queryDictString = queryDictToString(data);
  return bdayGet(`${baseMyCardsApi}${queryDictString}`);
}
export const getCardNav = (data) => {
  const { ...queryDict } = data;
  const queryDictString = queryDictToString(queryDict);
  return bdayGet(`${baseCardCategoryApi}${queryDictString}`);
}
export const getCardBreadcrumbs = (data) => {
  return bdayPost(`${baseApi}/breadcrumbs`, data);
}
export const getCardSend = (data) => {
  const { id, search } = data;
  return bdayGet(`${baseApi}/send/${id}${search}`);
}
export const addCardSend = (data) => {
  return bdayPost(`${baseApi}/send`, data);
}
export const updateCardSend = (data) => {
  return bdayPut(`${baseApi}/send`, data);
}
export const updateCardSendMessage = (data) => {
  return bdayPut(`${baseApi}/send/message`, data);
}
export const updateCardSendBackground = (data) => {
  return bdayPut(`${baseApi}/send/background`, data);
}
export const updateCardSendMember = (data) => {
  return bdayPut(`${baseApi}/send/member`, data);
}
export const sendCardSend = (data) => {
  return bdayPut(`${baseApi}/send/send`, data);
}
export const getCard = (data) => {
  const { id, search } = data;
  return bdayGet(`${baseApi}/assets/${id}${search}`);
}
export const receiveCard = (data) => {
  return bdayPost(`${baseApi}/receive`, data);
}
export const createCard = (data) => {
  return bdayPost(`${baseApi}/create`, data);
}
export const deleteSendCard = (data) => {
  return bdayPost(`${baseCardSendApi}/delete`, data);
}
export const addCardSign = (data) => {
  return bdayPost(`${baseApi}/sign`, data);
}
export const editCardSign = (data) => {
  return bdayPut(`${baseApi}/sign`, data);
}
export const receiveGroupCard = (data) => {
  return bdayPost(`${baseApi}/sign/receive`, data);
}
export const sendThankYouEmail = (data) => {
  return bdayPost(`${baseApi}/thankyou`, data);
}
export const saveCard = (data) => {
  return bdayPost(`${baseApi}/save`, data);
}
export const favoriteCard = (data) => {
  return bdayPost(`${baseApi}/favorite`, data);
}
